import React, { useState } from 'react';
import Footer from './Footer';


function AgeGateModal({ onAgeVerify }) {
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');

  const handleYes = () => {
    setError('');
    // Only set a persistent cookie if "Remember me" is checked.
    if (remember) {
      document.cookie = "over18=true; path=/; max-age=31536000"; // 1 year
    }
    // Grant access for the current session.
    onAgeVerify(true);
  };

  const handleNo = () => {
    setError('You must be 18 or older to access this site.');
  };

  return (
    <>
 
      <div className="age-gate-modal">
        <div className="age-gate-content">
          <figure className="modal-logo">
            <figcaption>Carlsberg</figcaption>
          </figure>
          <h2 className="modal-headline">Are you 18 years or older?</h2>
          <div className="button-group">
            <button onClick={handleNo}>
              Not Yet
            </button>
            <button onClick={handleYes}>
              Yes
            </button>
          </div>
          <label className="remember-me">
            <input
              type="checkbox"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
            />
            <span className="checkbox"></span>
            Remember me on this device (don’t tick if this is a shared computer)
          </label>
          {error && <p className="error-message">{error}</p>}
          
        </div>
       
        <Footer />
      </div>
      
      
    </>
    
  );
}

export default AgeGateModal;